import { render, staticRenderFns } from "./CardHead.vue?vue&type=template&id=52158bb5&scoped=true&"
import script from "./CardHead.vue?vue&type=script&lang=js&"
export * from "./CardHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52158bb5",
  null
  
)

export default component.exports